import { render } from "./ModalClaim.vue?vue&type=template&id=40a47483&scoped=true"
import script from "./ModalClaim.vue?vue&type=script&lang=js"
export * from "./ModalClaim.vue?vue&type=script&lang=js"

import "./ModalClaim.vue?vue&type=style&index=0&id=40a47483&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a47483"]])

export default __exports__